import { createUseRecipeHook, RecipeVariants } from '@/theme';
import * as style from './CardGrid.css';

export const useCardGridStyle = createUseRecipeHook(style.root);

export type CardGridStyleProps = RecipeVariants<typeof style.root>;
